import { useMediaQuery } from 'react-responsive';

const OneColumnView = ({ children }) => {
	const isOneColumnView = useMediaQuery({ maxWidth: 1161 });
	return <>{isOneColumnView && children}</>;
};

export default OneColumnView;
